import axios from 'axios';
import querystring from 'querystring';
import {
    FETCH_LANG_MENU_SUCCESS,
    FETCH_LANG_DATE_FILTER_SUCCESS,
    FETCH_LANG_FULL_MONTH_SUCCESS,
    FETCH_LANG_SHORT_MONTH_SUCCESS,
    FETCH_LANG_MASTER_SUCCESS
} from '../constants/ActionTypes';

export const fetchLangMenuSuccess = data => {
    return {
        type: FETCH_LANG_MENU_SUCCESS,
        payload: data
    }
}

export const fetchLangDateFilterSuccess = data => {
    return {
        type: FETCH_LANG_DATE_FILTER_SUCCESS,
        payload: data
    }
}

export const fetchLangFullMonthSuccess = data => {
    return {
        type: FETCH_LANG_FULL_MONTH_SUCCESS,
        payload: data
    }
}

export const fetchLangShortMonthSuccess = data => {
    return {
        type: FETCH_LANG_SHORT_MONTH_SUCCESS,
        payload: data
    }
}

export const fetchLangMasterSuccess = data => {
    return {
        type: FETCH_LANG_MASTER_SUCCESS,
        payload: data
    }
}

export const fetchLangMenu = (payload) => {
    const { company, language } = payload;
    let queryString = querystring.stringify({ company, language });
    
    return dispatch => {
        const url = `${process.env.REACT_APP_API_URL}language/menu?${queryString}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(response => {
            let data = {
                menuPerformanceOverall: response.data.menuPerformanceOverall,
                menuCustomer: response.data.menuCustomer,
                menuCustomerOverall: response.data.menuCustomerOverall,
                menuCustomerFocus: response.data.menuCustomerFocus,
                menuLogout: response.data.menuLogout
            }
            
            dispatch(fetchLangMenuSuccess(data))
        })
        .catch(error => {
            //dispatch(showKpiMessage(error.response));
        })
    }
}

export const fetchLangDateFilter = (payload) => {
    const { company, language } = payload;
    let queryString = querystring.stringify({ company, language });

    return dispatch => {
        const url = `${process.env.REACT_APP_API_URL}language/dateFilter?${queryString}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(response => {
            let data = {
                labelYear: response.data.labelYear,
                labelQuarter: response.data.labelQuarter,
                labelMonth: response.data.labelMonth,
                selectYear: response.data.selectYear,
                selectQuarter: response.data.selectQuarter,
                selectMonth: response.data.selectMonth
            }

            dispatch(fetchLangDateFilterSuccess(data))
        })
        .catch(error => {
            //dispatch(showKpiMessage(error.response));
        })
    }
}

export const fetchLangFullMonth = (payload) => {
    const { company, language } = payload;
    let queryString = querystring.stringify({ company, language });

    return dispatch => {
        const url = `${process.env.REACT_APP_API_URL}language/month?${queryString}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(response => {
            let data = {
                january: response.data.january,
                february: response.data.february,
                march: response.data.march,
                april: response.data.april,
                may: response.data.may,
                june: response.data.june,
                july: response.data.july,
                august: response.data.august,
                september: response.data.september,
                october: response.data.october,
                november: response.data.november,
                december: response.data.december,
            }
            
            dispatch(fetchLangFullMonthSuccess(data))
        })
        .catch(error => {
            
        })
    }
}

export const fetchLangShortMonth = (payload) => {
    const { company, language } = payload;
    let queryString = querystring.stringify({ company, language });

    return dispatch => {
        const url = `${process.env.REACT_APP_API_URL}language/monthShort?${queryString}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(response => {
            let data = {
                jan: response.data.jan,
                feb: response.data.feb,
                mar: response.data.mar,
                apr: response.data.apr,
                may: response.data.may,
                jun: response.data.jun,
                jul: response.data.jul,
                aug: response.data.aug,
                sep: response.data.sep,
                oct: response.data.oct,
                nov: response.data.nov,
                dec: response.data.dec,
            }

            dispatch(fetchLangShortMonthSuccess(data))
        })
        .catch(error => {
            
        })
    }
}

export const fetchLangMaster = (payload) => {
    const { company, language } = payload;
    let queryString = querystring.stringify({ company, language });

    return dispatch => {
        const url = `${process.env.REACT_APP_API_URL}language/master?${queryString}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(response => {
            let data = {
                person: response.data.person,
                persons: response.data.persons,
                baht: response.data.baht,
                day: response.data.day,
                amount: response.data.amount,
                quantity: response.data.quantity,
                percentage: response.data.percentage,
                previousSales: response.data.previousSales,
                currentSales: response.data.currentSales,
                total: response.data.total,
                currentYear: response.data.currentYear,
                previousYear: response.data.previousYear,
                currentQuarter: response.data.currentQuarter,
                previousQuarter: response.data.previousQuarter,
                currentMonth: response.data.currentMonth,
                previousMonth: response.data.previousMonth,
                search: response.data.search,
                status: response.data.status,
                year: response.data.year,
                quarter: response.data.quarter,
                month: response.data.month,
                selectYear: response.data.selectYear,
                selectQuarter: response.data.selectQuarter,
                selectMonth: response.data.selectMonth,
                noData: response.data.noData,
                connect: response.data.connect,
                disconnect: response.data.disconnect,
                customer: response.data.customer,
                ranking: response.data.ranking,
                group: response.data.group,
                address: response.data.address,
                province: response.data.province,
                tel: response.data.tel,
                map: response.data.map,
                contactPerson: response.data.contactPerson,
                noContactPerson: response.data.noContactPerson,
                aboutus: response.data.aboutus,
            }

            dispatch(fetchLangMasterSuccess(data))
        })
        .catch(error => {
            
        })
    }
}